export default `query GetCustomer {
  customer {
    addresses {
      id
    }
  }
}`
